import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Office} from '../../../classes/Office';
import {RelayBoard} from '../../../classes/RelayBoard';
import {OfficeService} from '../../../services/office.service';

@Component({
  selector: 'app-relay-board-edit',
  styleUrls: ['./relay-board-edit.component.scss'],
  templateUrl: './relay-board-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RelayBoardEditComponent implements OnInit {

  @Input() relayBoard: RelayBoard;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  offices: Office[];

  public relayBoardForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private officeService: OfficeService) {}

  ngOnInit(): void {

    if (this.relayBoard) {
      this.relayBoardForm = this.formBuilder.group({
        id: [this.relayBoard.id],
        name: [this.relayBoard.name, Validators.required],
        relayCount: [this.relayBoard.relayCount, Validators.required],
        host: [this.relayBoard.host, Validators.required],
        port: [this.relayBoard.port, Validators.required],
        officeId: [this.relayBoard.officeId, Validators.required]
      });
    } else {
      this.relayBoardForm = this.formBuilder.group({
        id: [''],
        name: ['', Validators.required],
        relayCount: ['', Validators.required],
        host: ['', Validators.required],
        port: ['', Validators.required],
        officeId: ['', Validators.required]
      });
    }

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
